import React, { useEffect, useRef, useState } from 'react';
import { Eye } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const formatNumber = (n) => new Intl.NumberFormat('en-US').format(n);

// Global module-level flag so multiple mounts of TotalViews components on the
// same page don't post a visit twice.
let visitPromise = null;
const getOrPostVisit = () => {
  if (visitPromise) return visitPromise;
  visitPromise = fetch(`${API}/site-stats/home/visit`, { method: 'POST' })
    .then((r) => r.json())
    .catch(() => ({ total_views: 0 }));
  return visitPromise;
};

const useCountUp = (target, duration = 1200) => {
  const [value, setValue] = useState(target);
  const prev = useRef(target);
  useEffect(() => {
    const start = performance.now();
    const from = prev.current;
    const delta = target - from;
    if (delta === 0) return undefined;
    let raf;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setValue(Math.round(from + delta * eased));
      if (t < 1) raf = requestAnimationFrame(tick);
      else prev.current = target;
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration]);
  return value;
};

const TotalViewsInline = () => {
  const [total, setTotal] = useState(0);
  const [ready, setReady] = useState(false);
  const displayed = useCountUp(total);

  useEffect(() => {
    let alive = true;
    getOrPostVisit().then((d) => {
      if (!alive) return;
      setTotal(d.total_views || 0);
      setReady(true);
    });
    return () => { alive = false; };
  }, []);

  return (
    <div data-testid="hero-total-views">
      <div className="text-[10px] uppercase tracking-[0.25em] text-white/80 mb-2 flex items-center gap-1.5">
        <Eye size={11} className="text-white" />
        <span>Total Views</span>
        <span className="relative flex ml-1">
          <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" />
        </span>
      </div>
      <div
        className={`text-lg md:text-xl font-serif-display text-white tabular-nums transition-opacity duration-500 ${ready ? 'opacity-100' : 'opacity-40'}`}
        style={{ textShadow: '0 2px 10px rgba(0,0,0,0.5)' }}
      >
        {formatNumber(displayed)}
      </div>
    </div>
  );
};

export default TotalViewsInline;
